<template>
    <div>
      <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
        {{ successMessage }}
      </div>
      <b-card>
        <b-row>
          <div class="col-12 mt-16">
            <b-form @submit.prevent="addUser" v-if="show">
              <div
                style="
                  background-color: rgb(97, 116, 152);
                  height: 32px;
                  border-radius: 4px;
                "
              >
                <h4
                  style="
                    color: rgb(223, 227, 238);
                    margin-left: 5px;
                    font-weight: bold;
                  "
                >
                Inspection Location Information
                </h4>
              </div>
              <div class="row">
                <div class="col-md-4 col-12">
                  <b-form-group id="input-group-1" label="Brand Name:" label-for="name">
                    <b-form-input
                      id="name"
                      type="text"
                      placeholder="Enter name"
                      autocomplete="off"
                      v-model="name"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="Description:" label-for="description">
                  <textarea class="form-control" id="description" type="text"
                  placeholder="Enter message" v-model="description" disabled/>
                </b-form-group>
              </div>
              </div>
            </b-form>
          </div>
        </b-row>
      </b-card>
    </div>
  </template>
  
  <script>
  import {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormSelect,
    BFormInput,
    BSpinner,
    BToast,
  } from "bootstrap-vue";
  // import axios from "axios";
  import axios from "../../../axios";
  export default {
    data() {
      return {
        show: true,
        name: "",
        image: "",
        description:"",
      };
    },
    components: {
      BRow,
      BCol,
      BCard,
      BButton,
      BForm,
      BFormGroup,
      BFormCheckboxGroup,
      BFormCheckbox,
      BFormSelect,
      BFormInput,
      BToast,
      BSpinner,
    },
    created() {
        // Load the clients data when the component is created
        axios
        const userId = this.$route.params.id;
        axios
            .get(`branchShow/${userId}`)
            .then((response) => {

                this.editedUser = response.data.data;
                this.name = this.editedUser.name ||'';
                this.description = this.editedUser.description ||'';            
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);
            });
    },
    methods: {
        showMsgBoxOne() {
            debugger;
        },
        onSubmit(event) {
            event.preventDefault();
            alert(JSON.stringify(this.form));
            // debugger
        },
        codeClick() {
            this.codeActive = !this.codeActive;
        },

        saveOwnCar() {
            this.showModal = false;
        },
    },
  };
  </script>
  